import { useState } from 'react'
import styled from 'styled-components'
import { Modal } from 'Components/Modal/Modal'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalBody } from 'Components/Modal/ModalBody'
import { StyledButton } from 'Components/Buttons/StyledButton'
import { FileType, FileUpload } from 'Components/Inputs/FileUpload'
import { AlertBanner } from 'Components/AlertBanner/AlertBanner'
import { ModalType, usePeoplePageContext } from 'Contexts/PeoplePageContext'
import { useBulkCreatePurchasesMutation } from 'Hooks/api/JOONAdmin/useBulkCreatePurchasesMutation'
import { ButtonContainer, spacingMD, spacingSM } from 'Utils/styles/spacing'
import { elfGreen, elfGreenFaded, mineralGreen } from 'Utils/styles/colors'
import { AppIconMap, AppIcons } from 'Utils/types/appIcons'

const Description = styled.p`
  color: ${mineralGreen};
  margin-bottom: ${spacingMD};
`

export const BulkPurchaseUploadModal = () => {
  const {
    state: { modal },
    setModal
  } = usePeoplePageContext()

  const [file, setFile] = useState<File | null>(null)
  const { mutate, isLoading } = useBulkCreatePurchasesMutation()

  const setShowModal = (show: boolean) => {
    if (!show) {
      setFile(null)
    }
    setModal(show ? ModalType.BulkPurchaseUpload : undefined)
  }

  const handleUpload = () => {
    if (!file) return
    const formData = new FormData()
    formData.append('file', file)
    mutate(formData)
  }

  return (
    <Modal
      showModal={modal === ModalType.BulkPurchaseUpload}
      setShowModal={setShowModal}
      minWidth={500}
    >
      <ModalHeader>Bulk Purchase Upload</ModalHeader>
      <ModalBody>
        <Description>
          Upload a CSV file to create multiple purchases at once. Each valid row will be
          auto-approved. Invalid rows will be skipped.
        </Description>

        <AlertBanner
          alert="CSV Format: user_id, name, description, amount, purchase_date (YYYY/MM/DD), benefit_program_id, joon_category_id"
          style={{
            padding: 10,
            marginBottom: spacingMD,
            border: `1px solid ${elfGreen}`,
            backgroundColor: elfGreenFaded,
            width: 'calc(100% - 22px)'
          }}
          iconSrc={AppIconMap[AppIcons.InfoCircle]}
        />

        <FileUpload setFileValue={setFile} fileType={FileType.Csv} />
      </ModalBody>

      <ButtonContainer gap={spacingSM}>
        <StyledButton secondary onClick={() => setShowModal(false)} id="cancel.label" />
        <StyledButton
          primary
          onClick={handleUpload}
          disabled={!file || isLoading}
          isLoading={isLoading}
          id="users.bulkPurchaseUpload.upload"
        />
      </ButtonContainer>
    </Modal>
  )
}
